import App from '@/models/App'

export default class OrganizationDetail extends App {
    static get entity() {
        return 'organizationDetails'
    }
    static get primaryKey() {
        return 'organizationId'
    }
    static fields() {
        return {
            organizationId: this.attr(''),
            nightTimeFrom: this.attr(''),
            nightTimeTo: this.attr(''),
        }
    }
}
